module.exports = __webpack_public_path__ + "img/premium.0a750ad5.png";